import * as React from "react";

function SvgAwsInventory(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 69 81"
      fill="#fff"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <use xlinkHref="#AwsInventory_svg__a" x={0.5} y={0.5} />
      <symbol id="AwsInventory_svg__a" overflow="visible">
        <path
          fill="#4b612c"
          d="M34 80H1.5Q0 80 0 78.25v-54.5c0-.75 1-1.5 1.75-2L34 3l32.25 18.75c.75.5 1.75 1.25 1.75 2v54.5Q68 80 66.5 80z"
          stroke="none"
        />
        <path
          fill="#759c3e"
          d="M34 78H1.5Q0 78 0 76.25v-54.5c0-.75 1-1.5 1.75-2L34 0l32.25 19.75c.75.5 1.75 1.25 1.75 2v54.5Q68 78 66.5 78z"
          stroke="none"
        />
        <path
          d="M8 25h52v46H8zm3 9h9v9h-9zm12 0h9v9h-9zM11 46h9v9h-9zm12 0h9v9h-9zM11 58h9v9h-9zm12 0h9v9h-9zm13-12h9v9h-9zm12 12h9v9h-9zm-12 0h9v9h-9z"
          stroke="none"
        />
      </symbol>
    </svg>
  );
}

export default React.forwardRef(SvgAwsInventory);
